import { useEffect } from 'react'
import { BlankViewImageVariant, BlankViewImageVariants } from 'src/Components/blank-view'
import e3dcBlankViewImageHappy from 'src/Resources/Images/blank-view/variants/e3dc-blank-view-happy.svg'
import e3dcBlankViewImageNeutral from 'src/Resources/Images/blank-view/variants/e3dc-blank-view-neutral.svg'
import e3dcBlankViewImageWorried from 'src/Resources/Images/blank-view/variants/e3dc-blank-view-worried.svg'
import flowBlankViewImageHappy from 'src/Resources/Images/blank-view/variants/flow-blank-view-happy.png'
import flowBlankViewImageNeutral from 'src/Resources/Images/blank-view/variants/flow-blank-view-neutral.png'
import flowBlankViewImageWorried from 'src/Resources/Images/blank-view/variants/flow-blank-view-worried.png'
import e3dcLightBackground from 'src/Resources/Images/logos/e3dc-light-background.svg'
import e3dcLogo from 'src/Resources/Images/logos/e3dc-logo.svg'
import flowLightBackground from 'src/Resources/Images/logos/flow-light-background.svg'
import flowLogo from 'src/Resources/Images/logos/flow-logo.svg'

export const isFlowTheme = process.env.REACT_APP_THEME === 'flow'

/**
 * Helper to distinguish a face (cartoon installation) between the variants and themes
 * @param variant BlankViewImageVariant
 * @returns Image-Src selected by variant and theme
 */
export const getThemedBlankViewImage = (variant: BlankViewImageVariant): string => {
  const happyFace = isFlowTheme ? flowBlankViewImageHappy : e3dcBlankViewImageHappy
  const worriedFace = isFlowTheme ? flowBlankViewImageWorried : e3dcBlankViewImageWorried
  const neutralFace = isFlowTheme ? flowBlankViewImageNeutral : e3dcBlankViewImageNeutral

  switch (variant) {
    case BlankViewImageVariants.Worried:
      return worriedFace
    case BlankViewImageVariants.Neutral:
      return neutralFace
    case BlankViewImageVariants.Happy:
      return happyFace
    default:
      return worriedFace
  }
}

type ThemedLogoWithProperties = {
  backgroundImage: string
  logo: string
  backgroundSize: {
    xs: string
    sm: string
    md: string
  }
}

/**
 * Hook for returning the (text-)logo and background-image (eg. e3dc-wave) according to the theme
 * @returns logo, backgroundImage and size for flow or e3ec
 */
export const getThemedLogoWithProperties = (): ThemedLogoWithProperties => {
  const backgroundImage = isFlowTheme ? flowLightBackground : e3dcLightBackground
  const logo = isFlowTheme ? flowLogo : e3dcLogo
  const backgroundSize = isFlowTheme
    ? {
        xs: 'contain',
        sm: 'contain',
        md: 'cover',
      }
    : {
        xs: 'auto 135%',
        sm: 'auto 97%',
        md: '90% auto',
      }

  return { backgroundImage, logo, backgroundSize }
}

/**
 * Sets the favIcon-Link according to the theme
 * Caution! The current favicon-file should sit in its themed-subfolder in the public-folder
 */
export const useThemedFavicon = (): void => {
  useEffect(() => {
    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']")

    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.href = `/${process.env.REACT_APP_THEME}/favicon.ico`
  }, [])
}
